import { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
import Data from "../data/Data";
import Header from './Header';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const formRef = useRef();
    const emailInputRef = useRef();
    const passwordInputRef = useRef();
    const navigate = useNavigate();
    const { isLoggedIn, login } = useAuth();

    useEffect(() => {
        if (isLoggedIn)
            navigate('/dashboard');
    }, [isLoggedIn, navigate])

    const handleInputChange = (e, ref) => {
        e.target.name === 'email' ? setEmail(e.target.value) : setPassword(e.target.value);
        emailInputRef.current.setCustomValidity('');
        passwordInputRef.current.setCustomValidity('');
        setErrorMessage('');
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (formRef.current.checkValidity() === false) {
            e.stopPropagation();
        } else {

            const response = await Data.fetchLogin(email, password);

            if (!response?.token) {
                // handle server-side error
                if (response === 'NO_USER_FOUND' || response === 'INVALID_PASSWORD' || response === 'NO_EMAIL_FOUND') {
                    setErrorMessage('Invalid email or password');
                    passwordInputRef.current.setCustomValidity('Invalid email or password');
                    emailInputRef.current.setCustomValidity('Invalid email or password');
                }
                else if (response === 'USER_NOT_VERIFIED') {
                    setErrorMessage('Account not verified. We sent you new verification.');
                    Data.sendVerification(email);
                }
                else {
                    setErrorMessage('Something went wrong');
                }
                setPassword('');
            } else {
                login();
                
                window.location = '/dashboard';
            }
        }

        setValidated(true);
    }

    return (
        <div>
            <Header whiteLogo />
            <div className="Login container-fluid d-flex justify-content-center align-items-center">
                <div className="col-12 col-lg-6 box">
                    <h1 className="mb-4">Login</h1>
                    {errorMessage && !errorMessage.includes('Invalid') &&
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            {errorMessage}
                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setErrorMessage('')}></button>
                        </div>
                    }
                    <form ref={formRef} className={`needs-validation ${validated ? 'was-validated' : ''}`} noValidate onSubmit={handleLogin}>
                        <div className="mb-3">
                            <label htmlFor="inputEmail" className="form-label">Email</label>
                            <input ref={emailInputRef} required type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" className="form-control" id="inputEmail" name="email" value={email} onChange={e => handleInputChange(e, emailInputRef)} />
                            <div className="invalid-feedback">
                                {emailInputRef.current &&
                                    (emailInputRef.current.validationMessage !== 'Something went wrong' &&
                                        emailInputRef.current.validationMessage !== 'Invalid email or password') ?
                                    (emailInputRef.current.validationMessage.includes('email') ?
                                        emailInputRef.current.validationMessage : 'Please enter a valid email address')
                                    : ''}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="inputPassword" className="form-label">Password</label>
                            <input ref={passwordInputRef} required type="password" className="form-control" id="inputPassword" name="password" value={password} onChange={e => handleInputChange(e, passwordInputRef)} />
                            <div className="invalid-feedback">
                                {passwordInputRef.current && passwordInputRef.current.validationMessage !== 'Something went wrong' ? (passwordInputRef.current.validationMessage.includes('email') ? passwordInputRef.current.validationMessage : 'Password is required') : ''}
                            </div>
                        </div>

                        <div className="row d-flex align-items-center">
                            <div className="col-7">
                                <a href="/forgot-password">Forgot Password?</a>
                            </div>
                            <div className="col-5 text-end">
                                <button className="btn btn-primary">Login</button>
                            </div>
                        </div>
                    </form>
                    <p className="create-account text-muted text-center mt-5">
                        Don't have an account yet? <a href="/sign-up"><b>Create Account</b></a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Login;